import {SessionSkeleton} from "./SessionSkeleton";
import Session from "./Session";

const Sessions = ({eventLoading, sessions, speakers}) => {
	const SessionsWithData = sessions.map(session => {
		return <Session key={session.ID} session={session} speakers={speakers}/>
	})

	return (
		<section id={'event_sessions'} className={'event-details'}>
			<div className={'event-info-list'}>
				{eventLoading ? SessionSkeleton : SessionsWithData }
			</div>
		</section>
	)
}

export default Sessions;
